__turbopack_context__.v({
  "footerContainer": "miiPsq_footerContainer",
  "footerItems": "miiPsq_footerItems",
});
